import Box from '@mui/material/Box';
import { nth } from 'lodash';
import useGetAvatarNotesHistory from '@/hooks/useGetAvatarNotesHistory';
import useGetMedias from '@/hooks/useGetMedias';
import ShowNoteImages from '@/components/common/notes/show-note-images/show-note-images';

interface ExportInterventionImagesProps {
    interventionId: string;
}

const ExportInterventionImages = ({ interventionId }: ExportInterventionImagesProps) => {
    const { history, isLoading: isLoadingHistory } = useGetAvatarNotesHistory({
        avatarId: interventionId,
    });

    const firstNote = nth(history, 0);
    const mediasIds = firstNote?.data?.medias.map((media: any) => media.id);

    const { images, isLoading: isLoadingMedias } = useGetMedias({ mediasIds });

    if (isLoadingHistory || isLoadingMedias || !images || images.length === 0) {
        return null;
    }

    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                py: 2,
            }}
        >
            <ShowNoteImages justOnceImage imagesUrls={images.map((item) => item.urlToDownload)} />
        </Box>
    );
};

export default ExportInterventionImages;
